import { normalizeRole } from './roles';

const ADMIN_ROLES = new Set(['client_admin', 'branch_admin']);
// `EMPLOYEE_ROLES` is what `SECTIONS.PIPELINE` reads, so this is the gate that
// decides whether a role can reach a loan file at all. The three added on
// 10 Sep work the pipeline; they are deliberately absent from the
// `loanInformation` case below, which is the leads list and originating work.
const EMPLOYEE_ROLES = new Set([
  'loan_officer',
  'loan_processor',
  'underwriter',
  'closer',
  'auditor',
]);

const isPlatformRole = (role) => {
  const value = String(role || '').toLowerCase();
  return value.includes('platform');
};

export const SECTIONS = {
  ADMIN: 'admin',
  ADMIN_INVITATIONS: 'admin_invitations',
  EMPLOYEE: 'employee',
  CONSUMER: 'consumer',
  PIPELINE: 'pipeline',
  LOAN_INFORMATION: 'loanInformation',
};

export function canAccessSection(section, role) {
  const normalized = normalizeRole(role);
  const raw = String(role || '').toLowerCase();

  switch (section) {
    case SECTIONS.ADMIN:
    case SECTIONS.ADMIN_INVITATIONS:
    case SECTIONS.EMPLOYEE:
      return isPlatformRole(raw) || ADMIN_ROLES.has(normalized);

    case SECTIONS.LOAN_INFORMATION:
      return ADMIN_ROLES.has(normalized) || normalized === 'loan_officer';

    case SECTIONS.PIPELINE:
      return ADMIN_ROLES.has(normalized) || EMPLOYEE_ROLES.has(normalized);

    default:
      return true;
  }
}

export function enforceAccessOrRedirect(section, role, fallbackPath) {
  if (canAccessSection(section, role)) {
    return null;
  }
  return fallbackPath;
}
